import React from 'react';
import {
  InfoModal,
  InfoModalLink,
} from 'src/components/atlas/molecules/InfoModal';

export interface SuggestedReadingModalProps {
  open: boolean;
  onClose: () => void;
}

const SUGGESTED_READING_LINKS: InfoModalLink[] = [
  {
    label: 'How to set up and update categories',
    href: 'https://help.vaultplatform.com/en/articles/8949978-how-to-create-new-categories-and-update-category-settings',
  },
  {
    label: "Vault's intake methods",
    href: 'https://help.vaultplatform.com/en/articles/6638099-what-is-vault-platform',
  },
];

const BODY_TEXT =
  "Experiencing an issue or unable to locate what you're looking for? Reach out via Technical Support and we'll be happy to assist you.";

/**
 * Suggested-reading info modal for the Category Configuration page.
 *
 * Configures the generic `InfoModal` molecule with the page-specific copy
 * and (currently placeholder) help-link hrefs. Mount inside
 * `<AtlasMuiThemeProvider>` and let the page consumer own `open` state.
 */
export const SuggestedReadingModal: React.FC<SuggestedReadingModalProps> = ({
  open,
  onClose,
}) => (
  <InfoModal
    open={open}
    onClose={onClose}
    title="Suggested reading"
    links={SUGGESTED_READING_LINKS}
    bodyText={BODY_TEXT}
  />
);
